import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import IndexTableContainer from '../../shared/components/tables/IndexTableContainer';
import { isFullyAssigned, formatStatus } from '../../helpers/shipments';
import ShippingColumn from './components/index/ShippingColumn';
import DisabledLink from './components/index/DisabledLink';
import AddressValidationTooltip from './components/index/AddressValidationTooltip';
// import toTitleCase from '../../helpers/toTitleCase';

class SalesShipmentsIndexContainer extends Component {
  formatContents = (shipment) => (
    shipment.shipmentRequests.map((sr) => {
      const {
        quantity,
        name,
        id,
        assignments,
      } = sr;
      return (
        <div key={`shipmentRequests${id}`} className="ml-4">
          <div>
            {`Qty ${quantity}`}
            <span className="ml-2">{name}</span>
          </div>
          {
            assignments.map((asgn, i) => {
              const { id: asgnId, contentIdentifiableId } = asgn;
              return (
                <div key={`asgn${asgnId}`} className="ml-4">
                  <span className="mr-2">{i + 1})</span>
                  { contentIdentifiableId }
                  {
                    contentIdentifiableId
                    && shipment.status === 'unfulfilled'
                    && (
                      <Link className="ml-1" to={`/orders/assignments/${asgnId}/remove`}>
                        <b>x</b>
                      </Link>
                    )
                  }
                  {
                    !contentIdentifiableId
                    && (shipment.userFlag || shipment.userUpdatesPending)
                    && <DisabledLink id={asgnId} userFlag={shipment.userFlag} />
                  }
                  {
                    !contentIdentifiableId
                    && shipment.status === 'unfulfilled'
                    && !shipment.userFlag
                    && !shipment.userUpdatesPending
                    && (
                      <Link
                        to={`/orders/assignments/${asgnId}/assign`}
                        className={shipment.userFlag && 'disabled-link'}
                      >
                        Assign
                      </Link>
                    )
                  }
                </div>
              );
            })
          }
        </div>
      );
    })
  )

  createRows = (list) => (
    list.map((salesShipment) => {
      const {
        id,
        trackingNumber,
        carrierServiceCode,
        name,
        status,
        userFlag,
        userUpdatesPending,
        orderTime,
        addressValidation,
        orderSource: {
          code: orderSourceCode,
          updateResponse: orderSourceUpdateResponse,
        },
      } = salesShipment;

      let displayCancel;
      let displayHold;
      let displayAcknowledge;
      if (status === 'unfulfilled') {
        displayCancel = (
          <Link to={`/orders/sales-shipments/${id}/cancel`}>
            Cancel
          </Link>
        );

        if (userFlag !== 'cancellation') {
          displayHold = (
            <Link to={`/orders/sales-shipments/${id}/hold`}>
              { userFlag === 'hold' ? 'Remove Hold' : 'Hold' }
            </Link>
          );
        }

        if (userUpdatesPending) {
          displayAcknowledge = (
            <Link to={`/orders/sales-shipments/${id}/acknowledge-updates`}>
              Acknowledge Updates
            </Link>
          );
        }
      }

      let displayTracking;
      let displayProcessed;
      if (status === 'unfulfilled' && isFullyAssigned(salesShipment)) {
        if (carrierServiceCode === 'pick_up') {
          displayTracking = 'Pick Up';
        } else {
          displayTracking = <ShippingColumn shipment={salesShipment} />;
        }

        if (trackingNumber || carrierServiceCode === 'pick_up') {
          displayProcessed = (
            <span>
              <Link className="ml-1" to={`/orders/sales-shipments/${id}/mark-as-processed`}>
                Mark As Processed
              </Link>
            </span>
          );
        }
      }

      return (
        <tr key={id}>
          <td>
            <div><b className="mr-3">ID</b>{id}</div>
            <div><b className="mr-3">Time</b>{orderTime}</div>
            <div><b className="mr-3">Status</b>{formatStatus(status)}</div>
            <div>
              <b className="mr-3">Recipient</b>
              {name}
              <span className="ml-1">
                {
                  addressValidation.status !== 'not_validated'
                  && (
                    <AddressValidationTooltip
                      id={`addr-${id}`}
                      validation={addressValidation}
                    />
                  )
                }
              </span>
            </div>
            <div>
              <b className="mr-3">Source</b>
              {orderSourceCode}
              {
                // eslint-disable-next-line no-nested-ternary
                status === 'fulfilled' && orderSourceCode === 'ship_station'
                  ? (
                    orderSourceUpdateResponse?.success
                      ? <span style={{ color: '#3F9E6B' }}> Updated</span>
                      : <span style={{ color: 'red' }}> Update Failed</span>
                  )
                  : null
              }
            </div>
          </td>
          <td>
            {
              userFlag === 'hold'
              && <div className="my-1"><Badge color="secondary">Hold Requested</Badge></div>
            }
            {
              userFlag === 'cancellation'
              && <div className="my-1"><Badge color="danger">Cancel Requested</Badge></div>
            }
            {
              userUpdatesPending
              && <div className="my-1"><Badge color="warning">Updates Pending</Badge></div>
            }
          </td>

          <td>{this.formatContents(salesShipment)}</td>
          <td>{displayTracking}</td>
          <td>
            <Link to={`/orders/sales-shipments/${id}`}>
              Show
            </Link>
            { displayCancel && <span className="mx-2">|</span> }
            { displayCancel }
            { displayHold && <span className="mx-2">|</span> }
            { displayHold }
            { displayProcessed && <span className="mx-2">|</span> }
            { displayProcessed }
            { displayAcknowledge && <span className="mx-2">|</span> }
            { displayAcknowledge }
          </td>
        </tr>
      );
    })
  )

  buildBadgeList = (filter, defaultFilter) => {
    const {
      contentId,
      processedDate,
      processedAfterDate,
      processedBeforeDate,
      search,
      status,
    } = filter;
    const {
      contentId: defaultContentId,
      processedDate: defaultProcessedDate,
      processedAfterDate: defaultProcessedAfterDate,
      processedBeforeDate: defaultProcessedBeforeDate,
      search: defaultSearch,
      status: defaultStatus,
    } = defaultFilter;

    const badgeList = [];
    Object.keys(filter).forEach((key) => {
      switch (key) {
        case ('contentId'):
          if (contentId && contentId !== defaultContentId) {
            badgeList.push(
              {
                order: 3,
                title: 'Contents',
                descFilterable: 'shipmentProfiles',
                filterKey: key,
              },
            );
          }
          break;
        case ('processedDate'):
          if (processedDate && processedDate !== defaultProcessedDate) {
            badgeList.push(
              {
                order: 4,
                title: 'Fulfillment Date',
                desc: filter[key],
                filterKey: key,
              },
            );
          }
          break;
        case ('processedAfterDate'):
          if (processedAfterDate && processedAfterDate !== defaultProcessedAfterDate) {
            if (!processedBeforeDate) {
              badgeList.push(
                {
                  order: 4,
                  title: 'Fulfilled After',
                  desc: filter.processedAfterDate,
                  filterKey: key,
                },
              );
            }
          }
          break;
        case ('processedBeforeDate'):
          if (processedBeforeDate && processedBeforeDate !== defaultProcessedBeforeDate) {
            if (processedAfterDate && processedAfterDate !== defaultProcessedAfterDate) {
              badgeList.push(
                {
                  order: 4,
                  title: 'Fulfilled Between',
                  desc: `${filter.processedAfterDate} and ${filter.processedBeforeDate}`,
                  filterKey: ['processedBeforeDate', 'processedAfterDate'],
                },
              );
            } else {
              badgeList.push(
                {
                  order: 4,
                  title: 'Fulfilled Before',
                  desc: filter[key],
                  filterKey: 'processedBeforeDate',
                },
              );
            }
          }
          break;
        case ('search'):
          if (search && search !== defaultSearch) {
            badgeList.push(
              {
                order: 1,
                title: 'Search',
                desc: filter[key],
                filterKey: key,
              },
            );
          }
          break;
        case ('status'):
          if (status && status !== defaultStatus) {
            badgeList.push(
              {
                order: 2,
                title: 'Status',
                desc: filter[key].replace(/_/g, ' '),
                filterKey: key,
              },
            );
          }
          break;
        // no default
      }
    });

    return badgeList;
  }

  render() {
    return (
      <IndexTableContainer
        newButtonText="New Sales Order"
        exportButton
        pageTitle="Sales Shipments"
        searchPlaceholder="Search by ID or Address..."
        heads={
          [
            { key: 'info', name: 'Info' },
            { key: 'flags', name: '' },
            { key: 'contents', name: 'Contents' },
            { key: 'tracking', name: 'Shipping Info' },
            { key: 'actions', name: 'Actions' },
          ]
        }
        filterForm={
          [
            {
              type: 'RadioButtonGroup',
              groupLabel: 'Shipment Status',
              filterKey: 'status',
              options: [
                { value: 'unfulfilled', label: 'Pending' },
                { value: 'fulfilled', label: 'Fulfilled' },
                { value: 'canceled', label: 'Canceled' },
                { value: '', label: 'All' },
              ],
            },
            {
              type: 'Select',
              groupLabel: 'Contents',
              filterKey: 'contentId',
              placeholder: 'Filter by Contents...',
              optionsKey: 'shipmentProfiles',
            },
            {
              type: 'DateTime',
              groupLabel: 'Fulfillment Date',
              filterKeys: {
                on: 'processedDate',
                before: 'processedBeforeDate',
                after: 'processedAfterDate',
              },
              filterTypes: ['on', 'before', 'after', 'range'],
            },
          ]
        }
        createRows={this.createRows}
        buildBadgeList={this.buildBadgeList}
      />
    );
  }
}

export default SalesShipmentsIndexContainer;
